import axios from "axios";
import { HTTP } from "@/api/http-common";
import { callApiRefreshToken } from "@/api/dang-nhap";
import store from "@/store";
import {
  LOCAL_STORAGE_KEY,
  removeValueToStorageByKey,
} from "@/utils/localStorage";
import router from "@/router";

import { ROUTE_NAME } from "@/constants/constants";

let requestsToRefresh = []
let isRefreshRequesting = false
const processQueue = (error, token) => {
  requestsToRefresh.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  requestsToRefresh = []
}

const actionLogout = () => {
  removeValueToStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
  removeValueToStorageByKey(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
  removeValueToStorageByKey(LOCAL_STORAGE_KEY.USER_ID);
  removeValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSION_DECENTRALIZATION);
  document.getElementById("overlay-common").style.display = "none";
  store.dispatch("common/setIsLogin", false);
  //router.push({ path: ROUTE_NAME.DANG_NHAP });
  window.location.replace(`${window.location.origin}/dang-nhap`)
}

axios.defaults.headers.post["Content-Type"] = "application/json";
HTTP.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
HTTP.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response, config } = error
    const originalRequest = config
    if (response.status === 401 && !originalRequest._retry) {
      if (isRefreshRequesting) {
        return new Promise(function (resolve, reject) {
          requestsToRefresh.push({ resolve, reject })
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token
            return axios(originalRequest)
          })
          .catch((err) => {
            return Promise.reject(err)
          })
      }
      originalRequest._retry = true
      isRefreshRequesting = true

      return new Promise((resolve, reject) => {
        const params = {
          accessToken: localStorage.getItem('accessToken'),
          refreshToken: localStorage.getItem('refreshToken'),
        }
        callApiRefreshToken(params).then((res) => {
          localStorage.setItem('accessToken', res.data.data.accessToken)
          localStorage.setItem('refreshToken', res.data.data.refreshToken)
        }).catch((err) => {
          actionLogout()
          processQueue(err, null)
          reject(err)
        }).finally(() => {
          isRefreshRequesting = false
        })
      })
    }
    return Promise.reject(error)
  }
);
